import { Row } from 'react-bootstrap'
import ServiceModel from '../../../data/entities/booking/ServiceModel'
import { sharedProperty } from '../../../hooks';
import BookServiceModal from '../modals/BookServiceModal';
import { BookingModel } from '../../../data/entities/booking/BookingModel';
import ServiceItem from './ServiceItem';
import { useServiceSelection } from '../hooks/useServiceSelection';

interface ServiceSelectionProps {
  services: ServiceModel[] | null;
  booking: sharedProperty<BookingModel>;
  locationId: number;
  className?: string;
}

export function ServiceSelection( { services, className, booking, locationId }: ServiceSelectionProps ) {

  const {
    showBookServiceState,
    bookServiceState,
    addBookingEvent,
    handleServiceClick,
  } = useServiceSelection(booking);

  if(!services) return <></>

  const bookedServiceIds = new Set(booking.value.bookingEvents.map(event => event.serviceId));

  return (
    <div className={className}>
      <Row className="d-flex justify-content-start mb-2">
        {services.map((service, index) => (
          <ServiceItem
            key={service.id ?? index}
            service={service}
            isBooked={bookedServiceIds.has(service.id)}
            onClick={() => handleServiceClick(service)}
          />
        ))}
      </Row>
      {bookServiceState.value.id && (
        <BookServiceModal
          showState={showBookServiceState}
          booking={booking}
          onSubmit={addBookingEvent}
          service={bookServiceState}
          locationId={locationId}
        />
      )}
    </div>
  )
}

export default ServiceSelection